// extracted by css-extract-rspack-plugin
export default {"body":"wO0oeyJ4bUbgIzsB"};